"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMap = void 0;
var Components = __importStar(require("./"));
exports.IconMap = {
    adjust: Components.Adjust,
    alignCenter: Components.AlignCenter,
    alignJustify: Components.AlignJustify,
    alignLeft: Components.AlignLeft,
    alignRight: Components.AlignRight,
    angleDoubleLeft: Components.AngleDoubleLeft,
    angleDoubleRight: Components.AngleDoubleRight,
    angleDown: Components.AngleDown,
    angleLeft: Components.AngleLeft,
    angleRight: Components.AngleRight,
    angleUp: Components.AngleUp,
    archiveFilled: Components.ArchiveFilled,
    archiveOutline: Components.ArchiveOutline,
    arrowDown: Components.ArrowDown,
    arrowLeft: Components.ArrowLeft,
    arrowRight: Components.ArrowRight,
    arrowUp: Components.ArrowUp,
    balanceFilled: Components.BalanceFilled,
    balanceOutline: Components.BalanceOutline,
    bandaidFilled: Components.BandaidFilled,
    bandaidOutline: Components.BandaidOutline,
    banFilled: Components.BanFilled,
    banOutline: Components.BanOutline,
    batteryFull: Components.BatteryFull,
    batteryLow: Components.BatteryLow,
    batteryMedium: Components.BatteryMedium,
    beach: Components.Beach,
    bellFilled: Components.BellFilled,
    bellOutline: Components.BellOutline,
    bloodPressureFilled: Components.BloodPressureFilled,
    bloodPressureOutline: Components.BloodPressureOutline,
    bold: Components.Bold,
    bookmarkFilled: Components.BookmarkFilled,
    bookmarkOutline: Components.BookmarkOutline,
    boxFilled: Components.BoxFilled,
    boxOutline: Components.BoxOutline,
    braille: Components.Braille,
    bricksFilled: Components.BricksFilled,
    bricksOutline: Components.BricksOutline,
    bridge: Components.Bridge,
    calendarFilled: Components.CalendarFilled,
    calendarOutline: Components.CalendarOutline,
    cameraFilled: Components.CameraFilled,
    cameraOutline: Components.CameraOutline,
    chatFilled: Components.ChatFilled,
    chatOutline: Components.ChatOutline,
    checkCircleFilled: Components.CheckCircleFilled,
    checkCircleOutline: Components.CheckCircleOutline,
    checkDefault: Components.CheckDefault,
    clearFormat: Components.ClearFormat,
    clip: Components.Clip,
    clockFilled: Components.ClockFilled,
    clockOutline: Components.ClockOutline,
    cloudFilled: Components.CloudFilled,
    cloudOutline: Components.CloudOutline,
    code: Components.Code,
    contrast: Components.Contrast,
    contrastActive: Components.ContrastActive,
    copyFilled: Components.CopyFilled,
    copyOutline: Components.CopyOutline,
    creditCardFilled: Components.CreditCardFilled,
    creditCardOutline: Components.CreditCardOutline,
    crossFilled: Components.CrossFilled,
    crossOutline: Components.CrossOutline,
    dataFilled: Components.DataFilled,
    dataOutline: Components.DataOutline,
    deaf: Components.Deaf,
    decreaseFont: Components.DecreaseFont,
    desktopFilled: Components.DesktopFilled,
    desktopOutline: Components.DesktopOutline,
    dogLeashed: Components.DogLeashed,
    dots: Components.Dots,
    download: Components.Download,
    dragdrop: Components.Dragdrop,
    dropFilled: Components.DropFilled,
    dropOutline: Components.DropOutline,
    dumbbellFilled: Components.DumbbellFilled,
    dumbbellOutline: Components.DumbbellOutline,
    emailFilled: Components.EmailFilled,
    emailOutline: Components.EmailOutline,
    exchange: Components.Exchange,
    exclamationDefault: Components.ExclamationDefault,
    exclamationTriangleFilled: Components.ExclamationTriangleFilled,
    exclamationTriangleOutline: Components.ExclamationTriangleOutline,
    expand: Components.Expand,
    eyeFilled: Components.EyeFilled,
    eyeHiddenFilled: Components.EyeHiddenFilled,
    eyeHiddenOutline: Components.EyeHiddenOutline,
    eyeOutline: Components.EyeOutline,
    faucetFilled: Components.FaucetFilled,
    faucetOutline: Components.FaucetOutline,
    fileEmptyFilled: Components.FileEmptyFilled,
    fileEmptyOutline: Components.FileEmptyOutline,
    fileVisualizationFilled: Components.FileVisualizationFilled,
    fileVisualizationOutline: Components.FileVisualizationOutline,
    fileWithItensFilled: Components.FileWithItensFilled,
    fileWithItensOutline: Components.FileWithItensOutline,
    filterFilled: Components.FilterFilled,
    filterOutline: Components.FilterOutline,
    folderFilled: Components.FolderFilled,
    folderOutline: Components.FolderOutline,
    gearFilled: Components.GearFilled,
    gearOutline: Components.GearOutline,
    glucometer: Components.Glucometer,
    hamburguerMenu: Components.HamburguerMenu,
    heartFilled: Components.HeartFilled,
    heartOutline: Components.HeartOutline,
    heartRateFilled: Components.HeartRateFilled,
    heartRateOutline: Components.HeartRateOutline,
    hospital: Components.Hospital,
    houseFilled: Components.HouseFilled,
    houseOutline: Components.HouseOutline,
    imageFilled: Components.ImageFilled,
    imageOutline: Components.ImageOutline,
    imcFilled: Components.ImcFilled,
    increaseFont: Components.IncreaseFont,
    infoCircleFilled: Components.InfoCircleFilled,
    infoCircleOutline: Components.InfoCircleOutline,
    infoDefault: Components.InfoDefault,
    italic: Components.Italic,
    keyFilled: Components.KeyFilled,
    keyOutline: Components.KeyOutline,
    lightbulbFilled: Components.LightbulbFilled,
    lightbulbOutline: Components.LightbulbOutline,
    link: Components.Link,
    list: Components.List,
    loading: Components.Loading,
    lockCloseFilled: Components.LockCloseFilled,
    lockCloseOutline: Components.LockCloseOutline,
    lockOpenFilled: Components.LockOpenFilled,
    lockOpenOutline: Components.LockOpenOutline,
    lungs: Components.Lungs,
    mapFilled: Components.MapFilled,
    mapMarkerFilled: Components.MapMarkerFilled,
    mapMarkerOutline: Components.MapMarkerOutline,
    mapOutline: Components.MapOutline,
    medicineBottleFilled: Components.MedicineBottleFilled,
    medicineBottleOutline: Components.MedicineBottleOutline,
    microphoneFilled: Components.MicrophoneFilled,
    microphoneOutline: Components.MicrophoneOutline,
    minimize: Components.Minimize,
    minus: Components.Minus,
    module: Components.Module,
    mugFilled: Components.MugFilled,
    mugOutline: Components.MugOutline,
    multipleUsers: Components.MultipleUsers,
    multipleUsersOutline: Components.MultipleUsersOutline,
    needleFilled: Components.NeedleFilled,
    needleOutline: Components.NeedleOutline,
    nurse: Components.Nurse,
    nurseOutline: Components.NurseOutline,
    nurseView: Components.NurseView,
    nurseVisualizationOutline: Components.NurseVisualizationOutline,
    o2Filled: Components.O2Filled,
    openDoor: Components.OpenDoor,
    pause: Components.Pause,
    penFilled: Components.PenFilled,
    penOutline: Components.PenOutline,
    penTool: Components.PenTool,
    petFilled: Components.PetFilled,
    petOutline: Components.PetOutline,
    phoneFilled: Components.PhoneFilled,
    phoneOutline: Components.PhoneOutline,
    pillFilled: Components.PillFilled,
    pillOutline: Components.PillOutline,
    pipeFilled: Components.PipeFilled,
    pipeOutline: Components.PipeOutline,
    playFilled: Components.PlayFilled,
    playOutline: Components.PlayOutline,
    plus: Components.Plus,
    pollFilled: Components.PollFilled,
    pollOutline: Components.PollOutline,
    presentationFilled: Components.PresentationFilled,
    presentationOutline: Components.PresentationOutline,
    printerFilled: Components.PrinterFilled,
    printerOutline: Components.PrinterOutline,
    qrCode: Components.QrCode,
    questionMarkFilled: Components.QuestionMarkFilled,
    questionMarkOutline: Components.QuestionMarkOutline,
    quoteLeft: Components.QuoteLeft,
    quoteRight: Components.QuoteRight,
    redo: Components.Redo,
    roadFilled: Components.RoadFilled,
    roadOutline: Components.RoadOutline,
    rocket: Components.Rocket,
    rulerFilled: Components.RulerFilled,
    rulerOutline: Components.RulerOutline,
    shieldFilled: Components.ShieldFilled,
    shieldOutline: Components.ShieldOutline,
    signLanguage: Components.SignLanguage,
    signOut: Components.SignOut,
    sort: Components.Sort,
    starFilled: Components.StarFilled,
    starOutline: Components.StarOutline,
    stethoscopeFilled: Components.StethoscopeFilled,
    stethoscopeOutline: Components.StethoscopeOutline,
    stopFilled: Components.StopFilled,
    stopOutline: Components.StopOutline,
    strikethrough: Components.Strikethrough,
    sync: Components.Sync,
    thermometerFilled: Components.ThermometerFilled,
    thermometerOutline: Components.ThermometerOutline,
    timerFilled: Components.TimerFilled,
    timerOutlined: Components.TimerOutlined,
    timesDefault: Components.TimesDefault,
    timesFilled: Components.TimesFilled,
    timesOutline: Components.TimesOutline,
    trashFilled: Components.TrashFilled,
    trashOutline: Components.TrashOutline,
    underline: Components.Underline,
    undo: Components.Undo,
    universalAccess: Components.UniversalAccess,
    upload: Components.Upload,
    userBan: Components.UserBan,
    userCard: Components.UserCard,
    userCheck: Components.UserCheck,
    userFilled: Components.UserFilled,
    userOutline: Components.UserOutline,
    userReturn: Components.UserReturn,
    userTimes: Components.UserTimes,
    videoFilled: Components.VideoFilled,
    videoOutline: Components.VideoOutline,
    volumeFilled: Components.VolumeFilled,
    volumeMuteFilled: Components.VolumeMuteFilled,
    volumeMuteOutline: Components.VolumeMuteOutline,
    volumeOutline: Components.VolumeOutline,
    walker: Components.Walker,
    wheelchair: Components.Wheelchair,
    wifi: Components.Wifi,
    xp: Components.Xp,
    zoomMinusFilled: Components.ZoomMinusFilled,
    zoomMinusOutline: Components.ZoomMinusOutline,
    zoomOutline: Components.ZoomOutline,
    zoomPlusFilled: Components.ZoomPlusFilled,
    zoomPlusOutline: Components.ZoomPlusOutline,
};
//# sourceMappingURL=types.js.map